module.exports = __webpack_public_path__ + "img/invitationa.fdfa116f.png";